import React, { useRef, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import {
  withMobileDialog,
  Dialog,
  withStyles,
  DialogActions,
  DialogContent,
} from '@material-ui/core'
import { toggleDialog } from 'actions/view'
import Button from 'components/theme/Button'
import { deleteSuccess } from 'actions/data'
import EmailEditor from 'react-email-editor'
import Field from 'components/theme/Field'
import { uploadToS3, listFiles } from 'actions/s3Manager'

export default withRouter(
  connect(
    state => ({
      dialogOpen: state.view.dialogs?.PageEditor?.open,
      fileList: state.s3Manager.fileList,
    }),
    dispatch =>
      bindActionCreators(
        {
          toggleDialog,
          deleteSuccess,
          uploadToS3,
          listFiles,
        },
        dispatch,
      ),
  )(
    withMobileDialog()(
      withStyles(theme => ({
        rounded: {
          // borderRadius: 28,
          // overflowY: 'hidden',
          // // height: '100%',
          // [theme.breakpoints.down('sm')]: {
          //   borderRadius: 0,
          //   overflowY: 'auto',
          // },
        },
        dialogContentRoot: {
          padding: 0,
          '&:first-child': {
            paddingTop: 0,
          },
        },
      }))(
        ({
          fullScreen,
          dialogOpen,
          classes,
          toggleDialog,
          history,
          content,
          id,
          uploadToS3,
          listFiles,
          fileList,
        }) => {
          const emailEditorRef = useRef(null)
          const [fileName, changeFileName] = useState('index')

          const exportHtml = () => {
            emailEditorRef.current.editor.exportHtml(data => {
              const { html } = data

              const blob = new Blob([html], {
                type: 'text/html',
              })

              const file = new File([blob], `${fileName}.html`, {
                type: 'text/html',
                lastModified: new Date(),
              })
              return uploadToS3(
                (fileList ? fileList.Prefix : '') + `${fileName}.html`,
                file,
              ).then(() => {
                listFiles(fileList ? fileList.Prefix : '')
              })
            })
          }

          const onLoad = () => {
            // editor instance is created
            // you can load your template here;
            // const templateJson = {};
            // emailEditorRef.current.editor.loadDesign(templateJson);
          }

          const onReady = () => {
            // editor is ready
            console.log('onReady')
          }

          return (
            <Dialog
              fullWidth
              maxWidth="xl"
              fullScreen
              open={Boolean(dialogOpen)}
              onClose={() => {
                toggleDialog({
                  open: false,
                  dialog: 'PageEditor',
                })
              }}
              aria-labelledby="responsive-dialog-title"
              PaperProps={{ classes: { rounded: classes.rounded } }}
            >
              <DialogContent classes={{ root: classes.dialogContentRoot }}>
                <div>
                  <div style={{ padding: 10, position: 'relative' }}>
                    <div style={{ width: 180, display: 'inline-block' }}>
                      <Field
                        label="File name"
                        variant="standard"
                        value={fileName}
                        handleChange={(property, value) =>
                          changeFileName(value)
                        }
                      />
                    </div>
                    <div
                      style={{ position: 'absolute', bottom: 35, left: 192 }}
                    >
                      .html
                    </div>
                  </div>
                  <div>
                    <EmailEditor
                      style={{ minHeight: 800 }}
                      ref={emailEditorRef}
                      onLoad={onLoad}
                      onReady={onReady}
                    />
                  </div>
                </div>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => exportHtml()} color="primary">
                  Save
                </Button>
                <Button
                  onClick={() => {
                    toggleDialog({
                      open: false,
                      dialog: 'PageEditor',
                    })
                  }}
                  color="primary"
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          )
        },
      ),
    ),
  ),
)
